import { __assign, __rest } from "tslib";
import React from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { withStyles } from '@material-ui/core/styles';
var Pager = function (_a) {
  var styles = _a.styles,
    props = __rest(_a, ["styles"]);
  if (styles) {
    var Pa = withStyles(styles)(Pagination);
    return /*#__PURE__*/React.createElement(Pa, __assign({}, props));
  } else {
    return /*#__PURE__*/React.createElement(Pagination, __assign({}, props));
  }
};
export default Pager;